import axios from 'axios'

const URL = 'https://divine-limit-eb3b.zaatdev.workers.dev'

const formHandler = async data => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  try {
    await axios.post(
      URL,
      { ...data, timeZone },
      {
        headers: { Accept: 'application/json' },
      },
    )
    return true
  } catch (e) {
    return false
  }
}
export default formHandler
